import { apiClient } from './apiClient';

export const TRANG_THAI_GIAY_TO_API_END_POINT = "trang-thai-giay-to";

export const trangThaiGiayToApi = {
    // Lấy tất cả tôn giáo
    selectAll: () => apiClient.get(`${TRANG_THAI_GIAY_TO_API_END_POINT}`),
};
